import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from '@mui/material'
import { withStyles } from '@mui/styles'
import StyledButton from './StyledButton'

export const StyledDialog = withStyles(theme => ({
    root: {
        zIndex: theme.zIndex.modal + 1
    },
}))(Dialog); 

export default function Confirmation(props) {
    const {open, setOpen, onSubmit, title = '', content = ''} = props

    return (
        <StyledDialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <StyledButton onClick={() => setOpen(false)} color="secondary">
            Cancel
            </StyledButton>
            <Button onClick={() => {setOpen(false); onSubmit();}} color="primary">
            OK
            </Button>
        </DialogActions>
        </StyledDialog>
    );
}
